module.exports = __webpack_public_path__ + "img/unknown-3.746abdac.svg";